<template>
  <div class="updateDeliveryInfo cus-modal" v-loading="loading">
    <OmsForm :form-config="formConfig" />
    <OmsButton class="modal-footer" :btn-config="btnConfig" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      formConfig: {
        formData: [
          {
            style: 'dropSelect',
            width: '24',
            colname: 'CP_C_PHY_WAREHOUSE_ID',
            itemdata: {
              hidecolumns: ['ECODE'],
              filterConds: [
                // 可用 = 是、仓库类型 = 仓库
                { fixcolumn: 'ISACTIVE', refobjid: 'Y' },
                // { fixcolumn: 'WH_TYPE', refobjid: '08' },
              ],
              colid: 167640,
              colname: 'CP_C_PHY_WAREHOUSE_ID',
              fkdisplay: 'drp',
              isfk: true, // 是否有fk键
              isnotnull: true, // 是否必填
              name: t('发货仓库'),
              readonly: false,
              pid: '',
              valuedata: '',
            },
            oneObj: (e) => {
              this.formConfig.formValue.CP_C_PHY_WAREHOUSE_ID = e.pid;
              this.formConfig.formValue.CP_C_PHY_WAREHOUSE_ENAME = e.valuedata;
            },
          },
          {
            style: 'dropSelect',
            width: '24',
            itemdata: {
              colid: 168212,
              colname: 'CP_C_LOGISTICS_ID', // 当前字段的名称
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              inputname: 'CP_C_LOGISTICS_ID:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: true, // 是否必填
              isuppercase: false, // 是否转大写
              name: t('物流公司'), // t('入库实体仓库')
              readonly: false, // 是否可编辑，对应input   readonly属性
              pid: '',
              valuedata: '', // 这个是选择的值
            },
            oneObj: (e) => {
              console.log(e);
              this.formConfig.formValue.CP_C_LOGISTICS_ID = e.pid;
              this.formConfig.formValue.CP_C_LOGISTICS_ENAME = e.valuedata;
            },
          },
          {
            style: 'input',
            value: 'EXPRESS_CODE',
            label: t('物流单号'),
            disabled: false,
            dataAcessKey: 'EXPRESS_CODE',
            width: '24',
          },
        ],
        formValue: {
          EXPRESS_CODE: '', // 备注
        },
        ruleValidate: {
          EXPRESS_CODE: [{ required: true, message: ' ', trigger: 'blur' }],
        },
      },
      btnConfig: {
        typeAll: 'default', // 按钮统一风格样式
        btnsite: 'right', // 按钮位置 (right , center , left)
        buttons: [
          {
            text: t('取消'),
            size: 'small', // 按钮大小
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            }, // 按钮点击事件
          },
          {
            type: 'primary',
            text: t('确定'),
            size: 'small', // 按钮大小
            btnclick: () => {
              this.determine();
            }, // 按钮点击事件
          },
        ],
      },
      loading: false,
    };
  },
  props: {
    componentData: {
      type: Object,
    },
  },
  watch: {
    componentData: {
      handler(v) {
        const { EXPRESSCODE, CP_C_PHY_WAREHOUSE_ID, CP_C_PHY_WAREHOUSE_ENAME, CP_C_LOGISTICS_ID, CP_C_LOGISTICS_ENAME } = v;
        this.formConfig.formValue.ID;
        this.formConfig.formValue.EXPRESS_CODE = EXPRESSCODE;
        this.formConfig.formData[0].itemdata.pid = CP_C_PHY_WAREHOUSE_ID;
        this.formConfig.formData[0].itemdata.valuedata = CP_C_PHY_WAREHOUSE_ENAME;
        this.formConfig.formValue.CP_C_PHY_WAREHOUSE_ID = CP_C_PHY_WAREHOUSE_ID;
        this.formConfig.formValue.CP_C_PHY_WAREHOUSE_ENAME = CP_C_PHY_WAREHOUSE_ENAME;
        this.formConfig.formData[1].itemdata.pid = CP_C_LOGISTICS_ID;
        this.formConfig.formData[1].itemdata.valuedata = CP_C_LOGISTICS_ENAME;
        this.formConfig.formValue.CP_C_LOGISTICS_ID = CP_C_LOGISTICS_ID;
        this.formConfig.formValue.CP_C_LOGISTICS_ENAME = CP_C_LOGISTICS_ENAME;
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  methods: {
    async determine() {
      const fromdata = new FormData();
      const { CP_C_PHY_WAREHOUSE_ID, CP_C_LOGISTICS_ID, EXPRESS_CODE } = this.formConfig.formValue;
      if (!CP_C_PHY_WAREHOUSE_ID) {
        return this.$Message.error('请选择发货仓库！');
      }
      if (!CP_C_LOGISTICS_ID) {
        return this.$Message.error('请选择物流公司！');
      }
      if (!EXPRESS_CODE) {
        return this.$Message.error('请填写物流单号！');
      }
      fromdata.append('id', this.componentData.ID);
      fromdata.append('logisticsId', CP_C_LOGISTICS_ID);
      fromdata.append('warehouseId', CP_C_PHY_WAREHOUSE_ID);
      fromdata.append('expresscode', EXPRESS_CODE);
      this.loading = true;
      this.service.common
        .publicUrlParams('/api/cs/oc/oms/v1/updateDeliveryInfo', fromdata)
        .then((res) => {
          if (res.data.code == 0) {
            this.$parent.$parent.closeConfirm();
            this.$parent.$parent.$parent.autoRefresh();
            // const tab = this.$parent.$parent.$parent.queryTab('OC_B_ORDER_DELIVERY');
            // this.$parent.$parent.$parent.labelClick(tab);
            this.$Message.success(res.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="less" scoped>
</style>
